const AccessTokenActionTypes = {
  SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
};

export default AccessTokenActionTypes;
